module.exports = __webpack_public_path__ + "static/media/xcultural2.39ee4080.jpg";